export const openHouseRegistration = {
  meta: {
    title: "Open House Registration | Gándara International School",
    description: "Book your spot at our next open house. Discover our Montessori methodology, facilities, and teaching team.",
  },
  hero: {
    title: "Open House",
    subtitle: "Come visit our Montessori school and register for our next open house",
    // ── Change this date for future open houses ──
    date: "February 28, 2026",
    badge: "Limited spots",
  },
  formTitle: "Book your spot",
  formSubtitle: "Fill in your details and we'll confirm your attendance",
  highlights: {
    title: "What will you discover?",
    items: [
      "Our Montessori methodology in action",
      "The facilities and natural spaces",
      "The teaching team and their pedagogical approach",
      "The trilingual model (Spanish, English, Galician)",
    ],
  },
};
